import React from 'react';

type ShowHideProps = {
    children: React.ReactNode;
    show?: boolean;
    fallback?: React.ReactNode;
};

export function ShowHide(props: ShowHideProps) {
    const {
        children,
        show = false,
        fallback,
    } = props;

    if (!show) {
        return fallback || null;
    }

    return (
        <>
            {children}
        </>
    );
}
